import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "exclusivePractice",
    name: "exclusivePractice",
    component: () => import("@/views/exclusive-practice/index.vue")
  }
];
export default routes;